import { partial } from 'lodash';

import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

export const type = 'timezone';

export const api = buildEntityApi(type, '/api/v3/timezones');

export const selectors = buildEntitySelectors(type, sel => {
  sel.label = partial(sel.dataItem, 'label');

  sel.all.choices = state =>
    sel.all.entities(state).map(entity => ({
      value: sel.id(entity),
      label: sel.label(entity),
    }));
});

export const actions = buildEntityActions(type, selectors, api);
